package dev.krno.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import dev.krno.rive.__krno
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private const val KOTLIN_SNIPPET =
    "suspend fun BrnKo() =\n" +
        "  coroutineScope {\n" +
        "    launch { talks() }\n" +
        "    launch { networking() }\n" +
        "    launch { beer() }\n" +
        "  }  // no leaks."

/**
 * Compact Kotlin code snippet with the Persona frame around it. The body is
 * contenteditable — a tiny JS module (`editable-snippet.js`) attaches on mount,
 * tokenizes on every keystroke, and re-applies our `.k-*` colour classes while
 * preserving the caret. Rendered in two places (hero on desktop, speakers grid
 * on compact); the effect below iterates over all mounted instances.
 */
@Composable
fun CompactCodeSnippet() {
    Div(attrs = { classes("code-snippet-compact") }) {
        Div(attrs = { classes("cs-chrome-compact") }) {
            Div(attrs = { classes("cs-dot", "cs-dot-r") })
            Div(attrs = { classes("cs-dot", "cs-dot-y") })
            Div(attrs = { classes("cs-dot", "cs-dot-g") })
            Span(attrs = { classes("cs-tab-compact") }) { Text("BrnKo.kt") }
        }
        // The JS highlighter takes over this element on mount. The Text() below
        // is only the initial payload — the tokenizer parses it, wraps each
        // token in .k-* spans, then re-runs on every `input` event.
        Div(attrs = {
            classes("cs-body-compact")
            attr("data-krno-editable", "kotlin")
        }) {
            Text(KOTLIN_SNIPPET)
        }
    }
}

/**
 * Global effect that hooks up every rendered `CompactCodeSnippet` to the JS
 * editor bridge. Mounted once from `App.kt` so it runs after both snippets are
 * in the DOM regardless of which layout is active.
 */
@Composable
fun EditableSnippets() {
    DisposableEffect(Unit) {
        val cleanup = __krno.mountEditableSnippets()
        onDispose {
            @Suppress("UNCHECKED_CAST")
            (cleanup as? () -> Unit)?.invoke()
        }
    }
}
